export const exportLocalData = (tabGroups) => {
    try {
        const result = JSON.stringify(tabGroups); // Make sure tabGroups is defined and accessible
        const rightNow = new Date();
        const dateCreated = rightNow
            .toISOString()
            .slice(0, 10)
            .replace(/-/g, '');

        // Creating a Blob from the JSON string
        const blob = new Blob([result], { type: 'application/json' });

        // Creating an object URL for the blob
        const url = URL.createObjectURL(blob);

        // Creating a temporary anchor element to trigger the download
        const a = document.createElement('a');
        a.href = url;
        a.download = 'tabExtend_data_' + dateCreated + '.json'; // Setting the file name for the download

        // Adding the anchor to the body, triggering the download, and then removing it
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // Revoking the blob URL to free up resources
        URL.revokeObjectURL(url);
    } catch (error) {
        alert('Error generating the download: ' + error.message);
    }
};

export const exportLocalDataToCSV = (tabGroups) => {
    try {
        // Construct CSV content
        let csvContent = 'data:text/csv;charset=utf-8,';
        csvContent += 'Title,Emoji,URL,Date Created,Comments,Group Title\n';

        tabGroups.forEach((group) => {
            if (group && Array.isArray(group.tabs)) {
                let groupTitle = group.emoji
                    ? `${group.title} ${group.emoji}`
                    : group.title;
                group.tabs.forEach((tab) => {
                    var row = `"${tab.title}","${tab.emoji}","${tab.url}","${tab.dateCreated}","${tab.comment}","${groupTitle}"\n`;
                    csvContent += row;
                });
            } else {
                // Handle the case when group is not structured as expected
                console.log('Group structure is not as expected:', group);
            }
        });

        var rightNow = new Date();
        var dateCreated = rightNow.toISOString().slice(0, 10).replace(/-/g, '');

        // Encoding the CSV content to ensure special characters are handled properly
        var blob = new Blob([decodeURIComponent(encodeURI(csvContent))], {
            type: 'text/csv;charset=utf-8;'
        });
        var url = URL.createObjectURL(blob);

        // Creating a temporary anchor element to trigger the download
        var a = document.createElement('a');
        a.href = url;
        a.download = 'tabExtend_data_' + dateCreated + '.csv';

        // Adding the anchor to the body, triggering the download, and then removing it
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // Revoking the blob URL to free up resources
        URL.revokeObjectURL(url);
    } catch (error) {
        alert('Error generating the download: ' + error.message);
    }
};

export const exportLocalDataToHTML = (tabGroups) => {
    try {
        // Start of HTML content
        let htmlContent = `
                    <html>
                    <head>
                        <title>Tab Export</title>
                    </head>
                    <body>
                    <h1>Tab Data</h1>
                    <table border='1'>
                    <tr>
                        <th>Title</th>
                        <th>Emoji</th>
                        <th>URL</th>
                        <th>Date Created</th>
                        <th>Comments</th>
                        <th>Group Title</th>
                    </tr>`;

        // Iterate over the JSON object to build HTML table rows
        tabGroups.forEach((group) => {
            if (group) {
                let groupTitle = group.emoji
                    ? group.title + ' ' + group.emoji
                    : group.title;
                if (Array.isArray(group)) {
                    group.forEach((tab) => {
                        htmlContent += `
                            <tr>
                                <td>${tab.title}</td>
                                <td>${tab.emoji}</td>
                                <td>${tab.url}</td>
                                <td>${tab.dateCreated}</td>
                                <td>${tab.comment}</td>
                                <td>${groupTitle}</td>
                            </tr>`;
                    });
                }
            }
        });

        // End of HTML content
        htmlContent += `
                    </table>
                    </body>
                    </html>`;

        var rightNow = new Date();
        var dateCreated = rightNow.toISOString().slice(0, 10).replace(/-/g, '');

        // Encode the HTML content
        var blob = new Blob([htmlContent], { type: 'text/html' });
        var url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'tabExtend_data_' + dateCreated + '.html'; // Setting the file name for the download

        // Adding the anchor to the body, triggering the download, and then removing it
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // Revoking the blob URL to free up resources
        URL.revokeObjectURL(url);
    } catch (error) {
        alert('Error generating the download: ' + error.message);
    }
};

export const exportToBookmarks = (tabGroups) => {
    function exportToHTML(tabGroups) {
        let htmlContent = `<!DOCTYPE NETSCAPE-Bookmark-file-1>
    <!-- This is an automatically generated file.
         It will be read and overwritten.
         DO NOT EDIT! -->
    <META HTTP-EQUIV="Content-Type" CONTENT="text/html; charset=UTF-8">
    <TITLE>Bookmarks</TITLE>
    <H1>Bookmarks</H1>
    <DL>\n`;

        function processGroup(group) {
            let groupContent = '';
            if (group.title) {
                groupContent += `<DT><H3 ADD_DATE="${Math.floor(
                    Date.now() / 1000
                )}" LAST_MODIFIED="${Math.floor(Date.now() / 1000)}">${
                    group.title
                }</H3>\n<DL>\n`;
            }

            group.tabs.forEach((tab) => {
                if (tab.url) {
                    let icon = tab.favIcon ? `ICON="${tab.favIcon}"` : '';
                    groupContent += `<DT><A HREF="${
                        tab.url
                    }" ADD_DATE="${Math.floor(
                        new Date(tab.dateCreated).getTime() / 1000
                    )}" ${icon}>${tab.title}</A>\n`;
                }
            });

            if (group.tabs.some((tab) => tab.stackedItems)) {
                group.tabs.forEach((tab) => {
                    if (tab.stackedItems) {
                        groupContent += processGroup({
                            title: tab.title,
                            tabs: tab.stackedItems
                        });
                    }
                });
            }

            if (group.title) {
                groupContent += `</DL>\n`;
            }
            return groupContent;
        }

        tabGroups.forEach((group) => {
            htmlContent += processGroup(group);
        });

        htmlContent += `</DL>\n`;
        return htmlContent;
    }

    const htmlOutput = exportToHTML(tabGroups); // yourData should be the JSON object containing your tabs and groups
    var rightNow = new Date();
    var dateCreated = rightNow.toISOString().slice(0, 10).replace(/-/g, '');
    // Assuming you're using a browser environment, you can trigger a download of this file:
    var blob = new Blob([htmlOutput], { type: 'text/html' });
    var url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'tabExtend_data_' + dateCreated + '.html'; // Setting the file name for the download

    // Adding the anchor to the body, triggering the download, and then removing it
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Revoking the blob URL to free up resources
    URL.revokeObjectURL(url);
};
